import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-newlayout-header',
  templateUrl: './newlayout-header.component.html',
  styleUrls: ['./newlayout-header.component.scss']
})
export class NewlayoutHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
